import { CalendarAndClock } from 'assets/icons/Icons';
import styled from 'styled-components';

export const Container = styled.div`
  text-align: center;
  display: flex;
  flex-direction: column;
`;

export const TitleSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
`;

export const CalendarAndClockIcon = styled(CalendarAndClock)`
  width: 24px;
  height: 24px;
`;

export const TitleIconContainer = styled.div`
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: linear-gradient(
    135deg,
    ${({ theme }) => theme.colors.yellow.darkYellow} 0%,
    ${({ theme }) => theme.colors.yellow.lighterYellow} 100%
  );
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Card = styled.div`
  flex: 1;
  align-items: center;
  border-radius: 8px;
  border-width: 0;
  background-color: ${({ theme }) => theme.colors.white};
  box-shadow: ${({ theme }) => theme.shadows.button.default};
  display: flex;
  flex-direction: column;
  padding: 1em 2em;
  width: 100%;
  padding: 16px 16px 32px 16px;
  gap: 24px;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.tabletLandscape}) {
    min-width: 700px;
    width: min-content;
    padding: 48px 64px 64px 64px;
    gap: 16px;
  }
`;

export const Name = styled.h2`
  color: ${({ theme }) => theme.colors.neutral.primaryNavy};
  text-align: center;
  ${({ theme }) => theme.fonts.DMSerif};
  font-size: 24px;
  font-style: normal;
  font-weight: 400;
  line-height: 32px;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.tabletLandscape}) {
    font-size: 32px;
  }
`;

export const ActionLink = styled.a`
  width: 100%;
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 48px;
  padding: 12px 16px;
  border-radius: 8px;
  text-decoration: none;
  background-color: ${({ theme }) => theme.colors.yellow.primary};
  color: ${({ theme }) => theme.colors.neutral.primaryNavy};
  box-shadow: ${({ theme }) => theme.shadows.button.default};
`;

export const Description = styled.p`
  background: white;
  text-align: left;

  ul {
    list-style-type: disc;
    margin: 1em 2em;
  }
`;
